AppVersionChangedModalInstanceCtrl.$inject = ["$uibModalInstance", "$localStorage"];export function AppVersionChangedModalInstanceCtrl($uibModalInstance, $localStorage) {
  "ngInject";
  var vm = this;
  vm.refresh = refresh;

  function refresh() {
    delete $localStorage['accountLastChecked']; // that way we force account data to be reloaded
    window.location.reload();
  }
}AppVersionChanged.$inject = ["Sync", "$uibModal"];


export function AppVersionChanged(Sync, $uibModal) {
  "ngInject";
  /**
               * @namespace AppVersionChanged
               * @returns {Factory}
               */
  var AppVersionChanged = {
    init: init,
    cleanup: cleanup,
    showRefreshModal: _fireModal };

  return AppVersionChanged;

  var unsub = function unsub() {
  };

  function init() {
    unsub = Sync.onVersionChanged(function (ver) {
      _fireModal();
      console.log('external app version changed to: ', ver);
    });
  }

  function cleanup() {
    unsub();
  }

  var modalInstance, modalShown;

  function _fireModal() {
    if (!modalShown) {
      modalShown = true;
      modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'templates/dashboard/app-version-changed.modal.html',
        controller: 'AppVersionChangedModalInstanceCtrl',
        controllerAs: 'vm',
        showClose: false,
        closeByEscape: false,
        closeByDocument: false,
        backdrop: 'static',
        keyboard: false });

      modalInstance.result.then(function (res) {
        console.log(res);
        modalShown = false;
      }, function () {
        console.log('Cancelled');
        modalShown = false;
      })['finally'](function () {
        // reset watch in case ResetModal is not required anymore
        watchInitialized();
        watchInitialized = null;
      });
    }
  }
}